export const Section = ({ ...props }) => {
  return (
    <svg
      width="1920"
      height="1200"
      viewBox="0 0 1920 1200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_0_109)">
        <rect width="1920" height="1200" fill="#050913" />
        <g filter="url(#filter0_f_0_109)">
          <rect
            x="408.965"
            y="325.41"
            width="443.677"
            height="411.141"
            transform="rotate(105 408.965 325.41)"
            fill="url(#paint0_linear_0_109)"
            fillOpacity="0.45"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_0_109"
          x="-502.999"
          y="-181.001"
          width="1311.96"
          height="1334.97"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_0_109"
          />
        </filter>
        <linearGradient
          id="paint0_linear_0_109"
          x1="567.421"
          y1="225.74"
          x2="922.268"
          y2="279.836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D009E" />
          <stop offset="0.505208" stopColor="#B3304A" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <clipPath id="clip0_0_109">
          <rect width="1920" height="1200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SectionSmallShadow = ({ ...props }) => {
  return (
    <div
      className="absolute right-4 top-40 h-48 w-36 rotate-45"
      style={{
        backgroundImage:
          'linear-gradient(90deg, #150343 0%, #4906D0 51%, #7907EE 100%)',
        filter: 'blur(120px)'
      }}
    ></div>
  );
};

export const SectionShadow = ({ ...props }) => {
  return (
    <div
      className="absolute left-40 top-64 h-96 w-48 rotate-45 opacity-20"
      style={{
        backgroundImage:
          'linear-gradient(90deg, #2D009E 0%, #B3304A 51%, #B3304A 100%)',
        filter: 'blur(200px)'
      }}
    ></div>
  );
};
